const GratefulNotification = `Oi _*{{CONTACT.NAME}}*_,

Olha eu aqui novamente! 🤭

Mas dessa vez para agradecer por ter respondido nossa pesquisa do projeto XPTO! 🤩

Sua ajuda faz toda a diferença para nós e para muitas outras mulheres.

Muito obrigad{{USER.PREFIX}}!

_*{{USER.NAME}}*_ e _*Equipe Projeto XPTO*_ _Universidade X_`;

export { GratefulNotification };
